// Submission de-duplication: most form libraries fire native submit + their
// own AJAX (sometimes more than one), and the post-submit "thank-you"
// MutationObserver may fire 5–30 s later when the success message renders
// (recaptcha + server roundtrip can stretch this on Elementor / WP). We
// suppress repeats within a 60 second window keyed by email when present
// (collapses the same submission across different formIds — Elementor's
// form.action vs admin-ajax.php URL vs "thankyou:/contact/", Framer's
// multiple AJAX calls, etc.) and fall back to formId when no email was
// provided. DJB2 keeps a small fingerprint string.
export function djb2(str) {
  var s = String(str || '');
  var h = 5381;
  for (var i = 0; i < s.length; i++) {
    h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  }
  return (h >>> 0).toString(36);
}

export function dedupKey(email, formId) {
  var trimmedEmail = (email || '').trim().toLowerCase();
  if (trimmedEmail) return djb2('e:' + trimmedEmail);
  return djb2('f:' + (formId || ''));
}

// Factory so each call site (and tests) can have an isolated map.
export function createDedup(now) {
  var clock = now || function () { return Date.now(); };
  var seen = {};
  return {
    isDuplicate: function (email, formId) {
      var key = dedupKey(email, formId);
      var t = clock();
      // GC entries older than 90s — slightly longer than the dedup
      // window so an entry stays in the map until its window expires.
      for (var k in seen) {
        if (Object.prototype.hasOwnProperty.call(seen, k)) {
          if (t - seen[k] > 90000) delete seen[k];
        }
      }
      // 60s is empirically long enough to cover recaptcha + server
      // roundtrip + thank-you-message render on slow WP/Elementor
      // installs, while still letting a genuine retry from the same
      // visitor (rare; usually a bot) re-submit after a minute.
      if (seen[key] && t - seen[key] < 60000) return true;
      seen[key] = t;
      return false;
    }
  };
}
